import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ListMusic, Plus } from "lucide-react";
import { toast } from "sonner";
import { Chip, inputCls } from "../components/Chips";
import { PlaylistCard, togglePlaylistLike } from "../components/PlaylistCard";
import { errMsg, http } from "../lib/api";

export default function Playlists() {
  const [tab, setTab] = useState("mine");
  const [lists, setLists] = useState(null);
  const [name, setName] = useState("");
  const load = useCallback(() => http.get(tab === "mine" ? "/playlists" : "/playlists/liked").then((r) => setLists(r.data)), [tab]);
  useEffect(() => { load(); }, [load]);

  const create = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await http.post("/playlists", { name: name.trim() });
      setName("");
      toast.success("Grojaraštis sukurtas");
      if (tab === "mine") load(); else setTab("mine");
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="space-y-10">
      <header className="rise">
        <p className="text-xs uppercase tracking-[0.2em] text-[var(--c-orange)] font-semibold mb-4">Kolekcijos</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold">Grojaraščiai</h1>
      </header>
      <form onSubmit={create} className="flex gap-3 max-w-lg">
        <input data-testid="playlist-name-input" value={name} onChange={(e) => setName(e.target.value)} maxLength={60}
          className={inputCls} placeholder="Naujo grojaraščio pavadinimas" />
        <button data-testid="playlist-create-button" className="flex items-center gap-2 px-6 rounded-full bg-[var(--c-orange)] text-white font-semibold text-sm hover:bg-[#ff7a26] transition-colors shrink-0">
          <Plus className="w-4 h-4" />Sukurti
        </button>
      </form>
      <div className="flex gap-2">
        <Chip testId="playlists-tab-mine" active={tab === "mine"} onClick={() => setTab("mine")}>Mano</Chip>
        <Chip testId="playlists-tab-liked" active={tab === "liked"} onClick={() => setTab("liked")}>Patinka</Chip>
      </div>
      {lists?.length === 0 && (
        <div data-testid="playlists-empty" className="text-center py-20 rounded-3xl border border-dashed border-[var(--c-line)] text-zinc-400">
          {tab === "mine"
            ? <>Dar neturite grojaraščių. Sukurkite pirmąjį ir pridėkite dainų mygtuku <ListMusic className="inline w-4 h-4" />.</>
            : <>Dar nepamėgote grojaraščių. <Link to="/atrasti" className="text-[var(--c-orange)] hover:underline">Atraskite kitų kūrėjų rinkinius</Link></>}
        </div>
      )}
      <div data-testid="playlists-grid" className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-x-5 gap-y-8">
        {lists?.map((pl, i) => (
          <PlaylistCard key={pl.id} pl={pl} index={i} showOwner={tab === "liked"} onLike={(p) => togglePlaylistLike(p, setLists)} />
        ))}
      </div>
    </div>
  );
}

